/* LmrbPackages.icon.svg.js */

module.exports = {
    icon: `
            <svg viewBox="-293 385 24 24" preserveAspectRatio="none">    
                <path fill="rgb(100, 197, 187)" d="M-292.4,395.8c-0.6-0.3-0.7-1-0.4-1.6l1.7-3c0.1-0.2,0.3-0.4,0.5-0.5l8.9-5c0.2-0.1,0.4-0.2,0.7-0.2c0.2,0,0.5,0.1,0.7,0.2
                    l9,5.1c0.2,0.1,0.4,0.3,0.5,0.5l1.7,2.9c0.3,0.5,0.1,1.2-0.4,1.6l-1.1,0.7v5.7c0,0.4-0.2,0.8-0.6,1l-9,5.1c-0.2,0.1-0.4,0.2-0.7,0.2
                    c-0.2,0-0.5-0.1-0.7-0.2l-9-5.1c-0.4-0.2-0.6-0.6-0.6-1v-6.3C-291.6,396-292.1,396-292.4,395.8 M-281,388L-281,388v7.7l0,0l6.8-3.8
                    L-281,388 M-289,401.5l6.9,3.9v-7.7l-6.9-3.9V401.5 M-273,401.5v-3.7l-5.7,3.3c-0.4,0.2-0.8,0.2-1.1,0v4.2L-273,401.5 M-278.9,398.6
                    l7.2-4.1l-0.7-1.2l-7.2,4.1L-278.9,398.6z"/>
            </svg>
        `
};
